import './root.css';
import 'bootstrap/dist/css/bootstrap.css';
// import 'font-awesome/css/font-awesome.min.css';
import 'antd/dist/antd.css';
import 'antd-mobile/dist/antd-mobile.css';
import { hydrate, render } from "react-dom";

import './custom/variables.css';
import './custom/antd-custom.css';
import './custom/style.css';


import React from 'react';
//import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './config';

import { createStore } from 'redux';
import allReducer from './reducers';
import { Provider } from 'react-redux';

import packageJson from '../package.json';
import ErrorBoundary from './GlobaljsErrorHandler';

const store = createStore(
  allReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const rootElement = document.getElementById('root');
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  hydrate(
    <BrowserRouter basename={baseUrl}>
      <Provider store={store}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
    , rootElement);
} else {
  render(
    <BrowserRouter basename={baseUrl}>
      <Provider store={store}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
    , rootElement);
}

let title = packageJson.title;

document.title = title;
sessionStorage.setItem('appTitle', title);

//ReactDOM.render(
//  <BrowserRouter basename={baseUrl}>
//    <Provider store={ store}>
//      <App />
//    </Provider>
//  </BrowserRouter>,
//  rootElement);

registerServiceWorker();

